export default "__VITE_ASSET__209PXOcC__"